export function update(metaSocialRecord) {
  document.title = metaSocialRecord.title

  updateMetaTag('meta-application-name', metaSocialRecord.title)
  updateMetaTag('meta-description', metaSocialRecord.description)
  updateMetaTag('meta-keywords', metaSocialRecord.keywords)

  updateMetaTag('meta-item-name', metaSocialRecord.title)
  updateMetaTag('meta-item-description', metaSocialRecord.description)
  updateMetaTag('meta-item-image', metaSocialRecord.image)

  updateMetaTag('twt-title', metaSocialRecord.title)
  updateMetaTag('twt-description', metaSocialRecord.description)
  updateMetaTag('twt-image', metaSocialRecord.image)

  updateMetaTag('og-title', metaSocialRecord.title)
  updateMetaTag('og-url', metaSocialRecord.url)
  updateMetaTag('og-image', metaSocialRecord.image)
  updateMetaTag('og-description', metaSocialRecord.description)

  document.head.querySelector('link[rel="canonical"]').href = metaSocialRecord.url
}

function updateMetaTag(tagName, value) {
  document.head.querySelector(`meta[id="${tagName}"]`).content = value
}
